const theme = {
    palette: {
        dark: "#7e7e7e",
        light: "#f4f4f4",
        border: "#d9d9d9",
        borderDark: '#c1c1c1',
        text: '#000'
    },
};

export default theme;
